export default __webpack_public_path__ + "static/media/c.591d1e39.mp3";